import { createSlice, type PayloadAction } from '@reduxjs/toolkit'

type AppSessionState = {
  location: any | null
  userPin: string[]
  userToken: string | null
  register?: any
  productViewMode: 'vertical' | 'horizontal'
  keyboardInputType: 'text' | 'number'
  showKeyboard: boolean
}

const initialState: AppSessionState = {
  location: null,
  userPin: [],
  userToken: null,
  register: null,
  productViewMode: 'vertical',
  keyboardInputType: 'text',
  showKeyboard: false,
}

const appSessionSlice = createSlice({
  name: 'app-session',
  initialState,
  reducers: {
    resetAppSession() {
      return initialState
    },

    setLocation(state, action: PayloadAction<any>) {
      state.location = action.payload
    },

    setUserPin(state, action: PayloadAction<any[]>) {
      state.userPin = action.payload
    },

    setUserToken(state, action: PayloadAction<string>) {
      state.userToken = action.payload
    },

    setRegister(state, action: PayloadAction<any>) {
      state.register = action.payload
    },

    setProductViewMode(
      state,
      action: PayloadAction<'vertical' | 'horizontal'>,
    ) {
      state.productViewMode = action.payload
    },

    setKeyboardInputType(state, action: PayloadAction<'text' | 'number'>) {
      state.keyboardInputType = action.payload
    },

    setShowKeyboard(state, action: PayloadAction<boolean>) {
      state.showKeyboard = action.payload
    },
  },
})

export const {
  resetAppSession,
  setLocation,
  setUserPin,
  setUserToken,
  setRegister,
  setProductViewMode,
  setKeyboardInputType,
  setShowKeyboard,
} = appSessionSlice.actions

export default appSessionSlice.reducer
